module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Applications_06-f7651a1c615ee3a9179296e77f24b442.jpg";